import React from 'react';
import PageSyle from '../style';
import NextBackNav from '../../../components/nextBackNav';
import CourseDescriptionV2 from '../../../components/courseDescriptionV2';
import CourseDescriptionV2Image from '../../../images/CCMRS/CCMRCourseDescriptionV201.png';
import RoundScreen from '../../../components/roundScreen';
import MultiHalfText from '../../../components/MultiHalfText';

export default function Page01({nextPressed, backPressed, nextSlideExzists, previousSlideExzists}) {
	let style = PageSyle();
	return (
		<div style={style.outerStyle()}>
			<CourseDescriptionV2
				texts={['2 Min Break each Round']}
				bgImage={CourseDescriptionV2Image}
				title={'HIIT / Plyometrics'}
			/>
			<MultiHalfText first='Workout 01' mt={true} />
			<RoundScreen
				isNumbered={false}
				rounds={[
					[
						{
							header: 'FULLBODY / HIT',
							value: 'Sides Lunges',
						},
						{
							header: 'REPS',
							value: '15',
						},
					],
					[
						{
							header: 'FULLBODY / HIT',
							value: 'Push - ups',
						},
						{
							header: 'REPS',
							value: '20',
						},
					],
					[
						{
							header: 'FULLBODY / HIT',
							value: 'Plyo Lunges',
						},
						{
							header: 'REPS',
							value: '12',
						},
					],
					[
						{
							header: 'FULLBODY / HIT',
							value: 'Burpees',
						},
						{
							header: 'REPS',
							value: '8',
						},
					],
					[
						{
							header: 'FULLBODY / HIT',
							value: 'Air Squats',
						},
						{
							header: 'REPS',
							value: '10',
						},
					],
				]}
			/>
			<NextBackNav
				message='Ready to continue?'
				mt={true}
				nextPressed={nextPressed}
				backPressed={backPressed}
				nextSlideExzists={nextSlideExzists}
				previousSlideExzists={previousSlideExzists}
			/>
		</div>
	);
}
